import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

// const lpMeisters = () => import('../views/lp-meisters.vue')
const lpKeenguin = () => import('../views/lp-keenguin.vue')
// const lpAwasu = () => import('../views/lp-awasu.vue')
// const lpKoukakukidoutai = () => import('../views/lp-koukakukidoutai.vue')
// const lpMume = () => import('../views/lp-mume.vue')
// const lpMumeBlog = () => import('../views/lp-mume-blog.vue')
// const lpMumeBlogs = () => import('../views/lp-mume-blogs.vue')
// const lpMumeNews = () => import('../views/lp-mume-news.vue')
// const lpMumeNewsList = () => import('../views/lp-mume-news-list.vue')
// const lpMumeStory = () => import('../views/lp-mume-story.vue')
// const lpKankitsu = () => import('../views/lp-kankitsu.vue')
// const lpKankitsuMagazines = () => import('../views/lp-kankitsu-magazines.vue')
// const lpKankitsuMagazine = () => import('../views/lp-kankitsu-magazine.vue')
// const lpTest2 = () => import('../views/lp-test2.vue')
// const lpValentine = () => import('../views/lp-valentine.vue')
// const lpWhiteday = () => import('../views/lp-whiteday.vue')
// const lpSummerchocolate = () => import('../views/lp-summerchocolate.vue')
// const lpHakunacrystal = () => import('../views/lp-hakunacrystal.vue')
// const lpKadodeShikou = () => import('../views/lp-kadodeshikou.vue')
// const lpSelection = () => import('../views/lp-selection.vue')
// const lpSelectionCurator = () => import('../views/lp-selection-curator.vue')
// const lpRikeiKiwami = () => import('../views/lp-rikeikyodaikiwami.vue')
// const lpRikeiKiwamiThanks = () => import('../views/thanks-rikei.vue')
// const lpRikeiKiwamiForm = () => import('../views/form-rikei.vue')
// const lpAliensGalaxy = () => import('../views/lp-aliensgalaxy.vue')
// const lpSolera = () => import('../views/lp-amber-solera.vue')
// const lpAmber = () => import('../views/lp-amber-brand.vue')
// const lpAmberYuzuru = () => import('../views/lp-amber-yuzuru.vue')
// const lpAmberAssemblage = () => import('../views/lp-amber-assemblage.vue')
// const lpAmberNews = () => import('../views/lp-amber-news.vue')
// const lpAmberNewsList = () => import('../views/lp-amber-news-list.vue')
// const lpAmberBlog = () => import('../views/lp-amber-blog.vue')
// const lpAmberBlogList = () => import('../views/lp-amber-blog-list.vue')
// const lpAmberStory = () => import('../views/lp-amber-story.vue')
// const lpShine = () => import('../views/lp-shine.vue')
// const lpShineThanks = () => import('../views/thanks-shin-e.vue')
// const lpShineForm = () => import('../views/form-shin-e.vue')

Vue.use(VueRouter)

const routes = [
  { path:'/mume/blog/68003',
    redirect: '/mume/news/68003'
  },
  {path: '/meisters'},{path: '/ghostintheshell-sac2045'},
  { path:'/zetsu'},{ path:'/shin-e'},{ path:'/inuneko-godwork'},{ path:'/aliens-galaxy/'},{ path: '/rikeikyodai-kiwami/'},{ path: '/hakunacrystal'},{ path: '/valentine'},{ path: '/whiteday'},{path: '/summerchocolate'},{path: '/kadode-shikou'},
  // アンバー
  { path: '/umeshu-the-amber-solera'},{ path: '/umeshu-the-amber/assemblage'},{ path: '/umeshu-the-amber/yuzuru'},{ path: '/umeshu-the-amber/'},{ path:'/umeshu-the-amber/news/:id'},{ path: '/umeshu-the-amber/news/'},{ path: '/umeshu-the-amber/blog/:id'},{ path: '/umeshu-the-amber/blog/'},{ path: '/umeshu-the-amber/story/:id'},
  // セレクション
  { path: '/selection'},{ path: '/selection/:title'},
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  // テストページ2 { path: '/lp-test2', name: 'test2', component: lpTest2, meta:{ title:'LPテストページ', desc:'LPのテストページ。主に公開済みのページを修正する際に使用する。', noindex: true } },
  // あわす
  {
    path: '/awasu',
    // name: 'awasu',
    // component: lpAwasu,
    // meta:{
    //   title:'あわす',
    //   desc:'モデル・デザイナーとして活躍する村田倫子さんがプロデュースする、すだち酒スパークリング「あわす」。徳島産のすだちをたっぷり使用した、爽やかな酸味とスパークリングの爽快感を楽しめます。',
    //   ogimage: require('../assets/lp/awasu/main_slide4.jpeg'),
    //   noindex: true
	  // }
  },
  // 金銀別誂
  {
    path:'/keenguin',
    name:'金銀別誂',
    component: lpKeenguin,
    meta:{
      title: 'プレミアム純米大吟醸「金銀 別誂」',
      desc:'茶聖・千利休が愛した名水で醸す、伝統と革新が織り成す、心揺さぶる甘美なプレミアム純米大吟醸酒「金銀 別誂」が誕生。遠心分離機で絞った数量限定商品につき、抽選制にて販売中です。',
      ogimage: require('../assets/lp/thumbnail/keenguin.jpg')
    }
  },
  // mume
  {
    path:'/mume', meta: { title: "mume"} // name:'mume', component:lpMume, meta: { title: '香り味わう天然梅酒 mume', desc:'はじめて梅畑を歩いたときの梅の香りは、今まで思っていた香りとは全く違っていました。完熟梅本来の香りを抽出すべく研究を重ねて生まれた、究極の梅酒「mume（ムメ）」。贅沢な香りを味わう新感覚の1本です。', ogimage: require('../assets/lp/mume/mume07.jpg') }
  },
  // mume ブログ
  {
    path: '/mume/blog', // name: 'mumeBlogs', component: lpMumeBlogs, meta: { title: '香り味わう天然梅酒 mume', desc:'', ogimage: require('../assets/lp/mume/mume07.jpg') }
  },
  // mume ブログ
  {
    path: '/mume/blog/:id', // name: 'mumeBlog', component: lpMumeBlog, meta:{ title:'香り味わう天然梅酒 mume', desc:'', ogimage: require('../assets/lp/mume/mume07.jpg'), }
  },
  // mume ニュース
  {
    path: '/mume/news/:id', // name: 'mumeNews', component: lpMumeNews, meta: { title: '香り味わう天然梅酒 mume', desc:'', ogimage: require('../assets/lp/mume/mume07.jpg') }
  },
  // mume ストーリー
  {
    path: '/mume/story/:id', // name: 'mumeStory', component: lpMumeStory, meta:{ title: '香り味わう天然梅酒 mume', desc:'', ogimage: require('../assets/lp/mume/mume07.jpg') }
  },
  // mume ニュース
  {
    path: '/mume/news', // name: 'mumeNewsList', component: lpMumeNewsList, meta:{ title:'香り味わう天然梅酒 mume', desc:'', ogimage: require('../assets/lp/mume/mume07.jpg'), }
  },
  // KANKITSU 
  {
    path: '/kankitsu', // name: 'kankitsu', component: lpKankitsu, meta: { title: 'フルーツボタニカルリキュール KANKITSU', desc:'「KANKITSU」は、「心に安心とワクワクを。」をブランド意義に掲げ、日々のリラックスタイムに新しい癒しとワクワクを提供するフルーツボタニカルリキュールブランドです。こだわりのフルーツとハーブをすべて手作業で仕込み、素材そのままのナチュラルな味わいを瓶に詰め込みました。さらに、国内特許を取得した桜由来の植物性乳酸菌を配合しており、ちょっぴり頑張りすぎてしまう貴方の毎日をサポートします。', ogimage: require('../assets/lp/thumbnail/kankitsu.jpg') }
  },
  // KANKITSU マガジン
  {
    path: '/kankitsu/magazine/', // name: 'kankitsuMagazines', component: lpKankitsuMagazines, meta: { title: 'フルーツボタニカルリキュール KANKITSU', desc:'「KANKITSU」は、「心に安心とワクワクを。」をブランド意義に掲げ、日々のリラックスタイムに新しい癒しとワクワクを提供するフルーツボタニカルリキュールブランドです。こだわりのフルーツとハーブをすべて手作業で仕込み、素材そのままのナチュラルな味わいを瓶に詰め込みました。さらに、国内特許を取得した桜由来の植物性乳酸菌を配合しており、ちょっぴり頑張りすぎてしまう貴方の毎日をサポートします。', ogimage: require('../assets/lp/thumbnail/kankitsu.jpg') }
  },
  // KANKITSUマガジン
  {
    path: '/kankitsu/magazine/:id', // name: 'kankitsuMagazine', component: lpKankitsuMagazine, meta: { title: 'フルーツボタニカルリキュール KANKITSU', desc:'「KANKITSU」は、「心に安心とワクワクを。」をブランド意義に掲げ、日々のリラックスタイムに新しい癒しとワクワクを提供するフルーツボタニカルリキュールブランドです。こだわりのフルーツとハーブをすべて手作業で仕込み、素材そのままのナチュラルな味わいを瓶に詰め込みました。さらに、国内特許を取得した桜由来の植物性乳酸菌を配合しており、ちょっぴり頑張りすぎてしまう貴方の毎日をサポートします。', ogimage: require('../assets/lp/thumbnail/kankitsu.jpg') }
  }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
export default router